<template>
  <div :class="$style.statsRow">
    <div v-for="stat in stats" :key="stat.label" :class="$style.statCard">
      <p :class="$style.label">{{ t(`neighbourhood.insights.${stat.label}`) }}</p>
      <p :class="$style.value">{{ stat.value }}</p>
      <p v-if="stat.subtitle" :class="$style.subtitle">{{ stat.subtitle }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

export interface StatCard {
  label: string;
  value: string;
  subtitle?: string;
}

defineProps<{
  stats: StatCard[];
}>();
</script>

<style module lang="scss">
@import '@/assets/variables';

.statsRow {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @container (max-width: #{$neighbourhood-stats-single-col-max}) {
    grid-template-columns: 1fr;
  }
}

.statCard {
  padding: 16px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  text-align: center;
  min-height: 78px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.label {
  font-size: 0.875rem; // 14px
  font-weight: 400;
  color: #595959;
  margin-bottom: 4px;
  letter-spacing: 0.01em;
}

.value {
  font-size: 1rem; // 16px
  font-weight: 800;
  color: #333333;
  margin-bottom: 0;
  line-height: 24px;
  white-space: normal;
  word-break: break-word;
}

.subtitle {
  font-size: 0.875rem;
  color: #595959;
  line-height: 21px;
}
</style>
